export enum BackendApi {
  GET_DATA_ANALYSES = 'private/doctor/get-data-analyses',
  GET_ALL_PATIENTS_DATA = "private/doctor/get-all-patients-data",
  GET_SIX_MONTHS_QUEST_DATA = "private/doctor/get-six-months-quest-data",
  LOGIN = 'auth/login',
  LOGOUT = 'auth/logout',
  USAGE_TIME = 'private/user/usage-time/',
  EDIT_PROFILE = 'private/user/edit-profile',
  EDIT_CHAT_NOTIFICATION = 'private/user/chat-notification',
  KEEP_ALIVE = 'private/user/keep-alive',
  PULL_UPDATES = 'private/user/pull-updates/',
  CHECK_PATIENT_ACTIVATION = 'private/patient/is-enabled/',
  ENABLE_PATIENT = 'private/patient/enable-patient/',
  QUESTIONNAIRE_SEND = 'private/patient/questionnaire/send',
  CHECK_GRADIMENTO_ALREADY_DONE = 'private/patient/questionnaire/gradimento/check',
  REGISTRATION = 'public/register',
  RECOVER_PWD = 'auth/login/recover-password',
  CHANGE_PWD = 'auth/login/change-password',
  CONFIRM_CHANGE_PWD = 'auth/login/change-password-confirm/',
  GET_DOCTOR_INFO = 'private/doctor/get-doctor-info/',
  GET_PATIENTS = 'private/doctor/get-patients/',
  GET_PATIENT = 'private/doctor/get-patient/',
  GET_BODYSTAT_PATIENT = 'private/doctor/get-bodystat-patient/',
  GET_GLOBAL_PATIENTS = 'private/doctor/get-global-patients/',
  GET_QUESTIONNAIRE = 'private/doctor/questionnaire/',
  GET_QUESTIONNAIRES = 'private/doctor/get-questionnaires/',
  GET_QUESTIONNAIRES_PATIENT = 'private/patient/get-questionnaires/',
  GET_QUESTIONNAIRES_STATS = 'private/doctor/questionnaires-stats',
  GET_QUESTIONNAIRES_TOTAL = 'private/doctor/questionnaires-total',
  GET_QUESTIONNAIRES_TOTAL_FEMALE = 'private/doctor/questionnaires-total-female',
  GET_QUESTIONNAIRES_TOTAL_MALE = 'private/doctor/questionnaires-total-male',
  GET_AVERAGE_QUESTIONNAIRES_PER_PATIENT = 'private/doctor/average-questionnaires-per-patient',
  GET_QUESTIONNAIRE_GRADIMENTO_SCORE_AVG = 'private/doctor/questionnaire-gradimento-score-avg',
  GET_QUESTIONNAIRE_GRADIMENTO_SUGGERIMENTI = 'private/doctor/questionnaire-gradimento-suggerimenti',

  GET_AVG_RETENTION_TIME = 'private/doctor/user-retention',
  GET_ETA_MEDIA_PER_SESSO = 'private/doctor/all-global-etamediagender-number',

  GET_PATIENTS_TOTAL = 'private/doctor/get-patients-gender-number',
  PATIENT_REGISTRATION = 'private/doctor/register-patient/',
  REMOVE_PATIENT = 'private/doctor/remove-patient/',
  SET_QUESTIONNAIRES = 'private/doctor/set-questionnaires/',
  SET_NEW_BIRTHDATE = 'private/doctor/edit-birthdate/',
  REMOVE_QUESTIONNAIRE = 'private/doctor/remove-questionnaire/',
  CREATE_AND_SEND_QUESTIONNAIRE = 'private/doctor/create-and-send-questionnaire/',
  ADD_JOB = 'private/doctor/add-job/',
  KILL_JOB = 'private/doctor/kill-job/',
  EDIT_PATIENT_CLINICAL_PROFILE = 'private/doctor/edit-patient-clinical-profile/',
  DELETE_NOTE = 'private/doctor/delete-note/',
  DELETE_THERAPY = 'private/doctor/delete-therapy/',
  READ_QUESTIONNAIRE = 'private/doctor/read-questionnaire/',
  WARN_DOCTOR = 'private/patient/warn-doctor-for-questionnaire/',
  GET_UPDATED_QUESTIONNAIRES = 'private/patient/get-updated-questionnaires/',
  GET_ALL_PENDING = 'private/patient/get-pending/',
  GET_ALL_CLINICAL_PENDING = 'private/doctor/get-clinical-pending/',
  SUBSCRIBE_TO_TOPIC = 'notification/subscribe',
  REMOVE_NOTIFICATION = 'private/notifications/remove/',
  READ_NOTIFICATION = 'private/notifications/read/',
  CLEAR_ALL_NOTIFICATIONS = 'private/notifications/remove-all/',
  GET_JOBS = 'private/doctor/get-jobs/',
  EVALUATE_QUESTIONNAIRE = 'private/doctor/evaluate-questionnaire/',
  GET_QUESTIONNAIRES_NOT_READ = 'private/doctor/get-not-read-questionnaires/',
  GET_GLOBAL_QUESTIONNAIRES_NOT_READ = 'private/doctor/get-global-not-read-questionnaires/',
  MARK_AS_READ_QUESTIONNAIRES = 'private/doctor/markAsReadQuestionnaires/',
  GET_ALL_FREQUENCY_QUESTIONNAIRES = 'private/doctor/frequency-questionnaires/',
  GET_INACTIVE_PATIENTS = 'private/doctor/inactive-patiets/',
  GET_QUESTIONNAIRES_TYPE_LIST = 'private/patient/questionnaires-type-list/',
  HAS_QUESTIONNAIRE_ALREADY_COMPLETED_TODAY = 'private/patient/hasQuestionnaireAlreadyCompletedToday/',
  GET_ALL_PATIENTS_NUMBER = 'private/doctor/get-all-patients-number/',
  GET_ALL_PATIENTS_TELEMEDICINE_NUMBER = 'private/doctor/get-all-patients-telemedicine-number/',
  GET_ALL_PATIENTS_STANDARD_NUMBER = 'private/doctor/get-all-patients-standard-number/',
  GET_ALL_CROHN_PATIENTS = 'private/doctor/get-all-crohn-patients/',
  GET_ALL_CROHN_PATIENTS_NUMBER = 'private/doctor/get-all-crohn-patients-number/',
  GET_ALL_UC_PATIENTS = 'private/doctor/get-all-uc-patients/',
  GET_ALL_UC_PATIENTS_NUMBER = 'private/doctor/get-all-uc-patients-number/',
  GET_ALL_ALTRO_PATIENTS = 'private/doctor/get-all-altro-patients/',
  GET_ALL_ALTRO_PATIENTS_NUMBER = 'private/doctor/get-all-altro-patients-number/',
  GET_CROHN_PATIENTS = 'private/doctor/get-crohn-patients/',
  GET_CROHN_PATIENTS_NUMBER = 'private/doctor/get-crohn-patients-number/',
  GET_UC_PATIENTS = 'private/doctor/get-uc-patients/',
  GET_UC_PATIENTS_NUMBER = 'private/doctor/get-uc-patients-number/',
  GET_ALTRO_PATIENTS = 'private/doctor/get-altro-patients/',
  GET_ALTRO_PATIENTS_NUMBER = 'private/doctor/get-altro-patients-number/',
  GET_INACTIVE_TELEMEDICINE_FOR_DOCTOR_PATIENTS = 'private/doctor/inactive-patients-telemedicine/',
  GET_INACTIVE_STANDARD_FOR_DOCTOR_PATIENTS = 'private/doctor/inactive-patients-standard/',
  GET_TELEMEDICINE_PATIENTS_FOR_DOCTOR = 'private/doctor/all-telemedicine/',
  GET_STANDARD_PATIENTS_FOR_DOCTOR = 'private/doctor/all-standard/',
  GET_GLOBAL_PATIENTS_TELEMEDICINE = 'private/doctor/all-global-telemedicine',
  GET_GLOBAL_PATIENTS_STANDARD = 'private/doctor/all-global-standard',
  GET_GLOBAL_PATIENTS_STANDARD_TELEMEDICINE_NUMBER = 'private/doctor/all-global-telemedicine-standard-number',
  GET_GLOBAL_PATIENTS_UCCDALTRO_NUMBER = 'private/doctor/all-global-uccdaltro-number',
  GET_GLOBAL_PATIENTS_UCCDALTRO_LOGINEXISTS_NUMBER = 'private/doctor/all-global-uccdaltro-loginexists-number',
  GET_GLOBAL_PATIENTS_INTERVENTI_NUMBER = 'private/doctor/all-global-interventi-number',
  GET_GLOBAL_PATIENTS_INTERVENTI_LOGINEXISTS_NUMBER = 'private/doctor/all-global-interventi-loginexists-number',
  GET_GLOBAL_PATIENTS_UOMODONNAALTRO_NUMBER = 'private/doctor/all-global-malefemaleother-number',
  GET_GLOBAL_PATIENTS_UOMODONNAALTRO_LOGINEXISTS_NUMBER = 'private/doctor/all-global-malefemaleother-loginexists-number',

  GET_GLOBAL_PATIENTS_AGES_NUMBER = 'private/doctor/all-global-ages-number',
  GET_GLOBAL_PATIENTS_AGES_LOGINEXISTS_NUMBER = 'private/doctor/all-global-ages-loginexists-number',

  GET_GLOBAL_PATIENTS_AGES_FROM_USER_NUMBER = 'private/doctor/all-global-ages-from-user-number',
  GET_GLOBAL_PATIENTS_AGES_FROM_USER_LOGINEXISTS_NUMBER = 'private/doctor/all-global-ages-from-user-loginexists-number',

  GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_NUMBER = 'private/doctor/all-global-age-of-diagnosis-number',
  GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_LOGINEXISTS_NUMBER = 'private/doctor/all-global-age-of-diagnosis-loginexists-number',

  GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_FROM_USER_NUMBER = 'private/doctor/all-global-age-of-diagnosis-from-user-number',
  GET_GLOBAL_PATIENTS_AGE_OF_DIAGNOSIS_FROM_USER_LOGINEXISTS_NUMBER = 'private/doctor/all-global-age-of-diagnosis-from-user-loginexists-number',

  GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_NUMBER = 'private/doctor/all-global-pathology-duration-number',
  GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_LOGINEXISTS_NUMBER = 'private/doctor/all-global-pathology-duration-loginexists-number',

  GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_FROM_USER_NUMBER = 'private/doctor/all-global-pathology-duration-from-user-number',
  GET_GLOBAL_PATIENTS_PATHOLOGY_DURATION_FROM_USER_LOGINEXISTS_NUMBER = 'private/doctor/all-global-pathology-duration-from-user-loginexists-number',

  GET_GLOBAL_PATIENTS_ACTIVETHERAPY_NUMBER = 'private/doctor/all-global-active-therapy-number',
  GET_GLOBAL_PATIENTS_ACTIVETHERAPY_LOGINEXISTS_NUMBER = 'private/doctor/all-global-active-therapy-loginexists-number',

  GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_MIAH_NUMBER = 'private/doctor/all-global-malattia-iniziale-miah-number',
  GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_MIAH_LOGINEXISTS_NUMBER = 'private/doctor/all-global-malattia-iniziale-miah-loginexists-number',

  GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_HBISCCAI_NUMBER = 'private/doctor/all-global-malattia-iniziale-hbisccai-number',
  GET_GLOBAL_PATIENTS_MALATTIA_INIZIALE_HBISCCAI_LOGINEXISTS_NUMBER = 'private/doctor/all-global-malattia-iniziale-hbisccai-loginexists-number',

  GET_GLOBAL_QUESTIONNAIRES_FOR_TYPE_NUMBER = 'private/doctor/all-global-questionnaires-for-type-number',


  GET_GLOBAL_INACTIVE_PATIENTS_TELEMEDICINE = 'private/doctor/all-global-inactive-telemedicine',
  GET_GLOBAL_INACTIVE_PATIENTS_STANDARD = 'private/doctor/all-global-inactive-standard',
  GET_NEVER_LOGGED = 'private/doctor/all-never-logged-patients',
  GET_NEVER_LOGGED_TELEMEDICINE = 'private/doctor/all-never-logged-patients-telemedicine',
  GET_NEVER_LOGGED_STANDARD = 'private/doctor/all-never-logged-patients-standard',
  GET_NEVER_LOGGED_TELEMEDICINE_NUMBER = 'private/doctor/all-never-logged-patients-telemedicine-number',
  GET_NEVER_LOGGED_STANDARD_NUMBER = 'private/doctor/all-never-logged-patients-standard-number',
  GET_NEVER_LOGGED_UC = 'private/doctor/all-never-logged-patients-uc',
  GET_NEVER_LOGGED_CD = 'private/doctor/all-never-logged-patients-cd',
  GET_NEVER_LOGGED_ALTRO = 'private/doctor/all-never-logged-patients-altro',
  GET_NEVER_LOGGED_UC_NUMBER = 'private/doctor/all-never-logged-patients-uc-number',
  GET_NEVER_LOGGED_CD_NUMBER = 'private/doctor/all-never-logged-patients-cd-number',
  GET_NEVER_LOGGED_ALTRO_NUMBER = 'private/doctor/all-never-logged-patients-altro-number',
  GET_NEVER_LOGGED_UOMO_NUMBER = 'private/doctor/all-never-logged-patients-male-number',
  GET_NEVER_LOGGED_DONNA_NUMBER = 'private/doctor/all-never-logged-patients-female-number',
  GET_NEVER_LOGGED_SESSONONSPECIFICATO_NUMBER = 'private/doctor/all-never-logged-patients-nosex-number',
  GET_NEVER_LOGGED_AGEBRACKET_NUMBER = 'private/doctor/all-never-logged-patients-agebracket-number',
  GET_NEVER_LOGGED_AGEOFDIAGNOSISBRACKET_NUMBER = 'private/doctor/all-never-logged-patients-ageofdiagnosisbracket-number',
  GET_NEVER_LOGGED_PATHOLOGY_DURATION_BRACKET_NUMBER = 'private/doctor/all-never-logged-patients-pathologydurationbracket-number',
  GET_NEVER_LOGGED_INTERVENTI_NUMBER = 'private/doctor/all-never-logged-patients-interventi-number',
  GET_NEVER_LOGGED_NO_INTERVENTI_NUMBER = 'private/doctor/all-never-logged-patients-nointerventi-number',
  GET_NEVER_LOGGED_THERAPY_ACTIVE_NUMBER = 'private/doctor/all-never-logged-patients-therapy-active-number',
  GET_NEVER_LOGGED_PATHOLOGY_DURATION_NUMBER = 'private/doctor/all-never-logged-patients-pathology-duration-number',


  GET_INACTIVE = 'private/doctor/all-inactive-patients',
  GET_INACTIVE_TELEMEDICINE_NUMBER = 'private/doctor/all-inactive-patients-telemedicine-number',
  GET_INACTIVE_STANDARD_NUMBER = 'private/doctor/all-inactive-patients-standard-number',
  GET_INACTIVE_UC_NUMBER = 'private/doctor/all-inactive-patients-uc-number',
  GET_INACTIVE_CD_NUMBER = 'private/doctor/all-inactive-patients-cd-number',
  GET_INACTIVE_ALTRO_NUMBER = 'private/doctor/all-inactive-patients-altro-number',
  GET_INACTIVE_UOMO_NUMBER = 'private/doctor/all-inactive-patients-male-number',
  GET_INACTIVE_DONNA_NUMBER = 'private/doctor/all-inactive-patients-female-number',
  GET_INACTIVE_SESSONONSPECIFICATO_NUMBER = 'private/doctor/all-inactive-patients-nosex-number',
  GET_INACTIVE_AGEBRACKET_NUMBER = 'private/doctor/all-inactive-patients-agebracket-number',
  GET_INACTIVE_AGEOFDIAGNOSISBRACKET_NUMBER = 'private/doctor/all-inactive-patients-ageofdiagnosisbracket-number',
  GET_INACTIVE_PATHOLOGY_DURATION_BRACKET_NUMBER = 'private/doctor/all-inactive-patients-pathologydurationbracket-number',
  GET_INACTIVE_INTERVENTI_NUMBER = 'private/doctor/all-inactive-patients-interventi-number',
  GET_INACTIVE_NO_INTERVENTI_NUMBER = 'private/doctor/all-inactive-patients-nointerventi-number',
  GET_INACTIVE_THERAPY_ACTIVE_NUMBER = 'private/doctor/all-inactive-patients-therapy-active-number',
  GET_INACTIVE_PATHOLOGY_DURATION_NUMBER = 'private/doctor/all-inactive-patients-pathology-duration-number',
  GET_INACTIVE_MALATTIA_INIZIALE_ATTIVA_HBISCCAI_NUMBER = 'private/doctor/all-inactive-patients-malattia-iniziale-attiva-hbisccai-number',
  GET_INACTIVE_MALATTIA_INIZIALE_INATTIVA_HBISCCAI_NUMBER = 'private/doctor/all-inactive-patients-malattia-iniziale-inattiva-hbisccai-number',
  GET_INACTIVE_MALATTIA_INIZIALE_ATTIVA_MIAH_NUMBER = 'private/doctor/all-inactive-patients-malattia-iniziale-attiva-miah-number',
  GET_INACTIVE_MALATTIA_INIZIALE_INATTIVA_MIAH_NUMBER = 'private/doctor/all-inactive-patients-malattia-iniziale-inattiva-miah-number',




  SEND_MAIL_INACTIVE = 'private/doctor/mail-to-inactive',
  GET_STABLE_AND_UNSTABLE_UC_PATIENTS = 'private/doctor/get-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_CROHN_PATIENTS = 'private/doctor/get-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_FEATURES = 'private/doctor/get-stable-unstable-features',

  GET_STABLE_AND_UNSTABLE_GENDER_UC_PATIENTS = 'private/doctor/get-gender-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_GENDER_CROHN_PATIENTS = 'private/doctor/get-gender-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_AGE_RANGE_UC_PATIENTS = 'private/doctor/get-age-range-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_AGE_RANGE_CROHN_PATIENTS = 'private/doctor/get-age-range-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_PREVIOUS_SURGERY_CROHN_PATIENTS = 'private/doctor/get-previous-surgery-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_PREVIOUS_SURGERY_UC_PATIENTS = 'private/doctor/get-previous-surgery-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_THERAPY_UC_PATIENTS = 'private/doctor/get-therapy-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_THERAPY_CROHN_PATIENTS = 'private/doctor/get-therapy-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_DURATION_CROHN_PATIENTS = 'private/doctor/get-duration-stable-unstable-crohn-patients',
  GET_STABLE_AND_UNSTABLE_DURATION_UC_PATIENTS = 'private/doctor/get-duration-stable-unstable-uc-patients',
  GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_HBI_CROHN_PATIENTS = 'private/doctor/get-initial-active-inactive-pathology-stable-unstable-hbi-crohn-patients',
  GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_SCCAI_UC_PATIENTS = 'private/doctor/get-initial-active-inactive-pathology-stable-unstable-sccai-uc-patients',
  GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_MIAH_CROHN_PATIENTS = 'private/doctor/get-initial-active-inactive-pathology-stable-unstable-miah-crohn-patients',
  GET_STABLE_AND_UNSTABLE_INITIAL_ACTIVE_INACTIVE_PATHOLOGY_MIAH_UC_PATIENTS = 'private/doctor/get-initial-active-inactive-pathology-stable-unstable-miah-uc-patients',
  CHANGE_PWD_AUTH = 'auth/login/change-password-auth',
  GET_UC_COMPARISONS = 'private/doctor/get-UC-comparisons',
  GET_CD_COMPARISONS = 'private/doctor/get-CD-comparisons',
  GET_UC_CD_COMPARISONS = 'private/doctor/get-UC-CD-comparisons',
  SEND_MAIL_UC_OTHER_PATINTS = 'private/doctor/mail-to-uc_other_patints'

}

//export const localhost = 'http://localhost:8080/';
export const localhost = 'https://ibdtool-be.herokuapp.com/';
